/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { queryKeys } from "./queryKeys";
import { createDetailQuery } from "./createQuery";

export const useLocation = createDetailQuery(queryKeys.location.detail, "/public/locations");
